/**
 * TODO: Standardize colors and use consistent scales (e.g. RED_100 - RED_900).
 * TODO: Rename PURPLE to INDIGO.
 */
export enum Color {
  TRANSPARENT = '#00000000',
  BLACK = '#000000',
  BLUISH_BLACK = '#202040',
  CHARCOAL = '#222224',
  CINDER = '#24292F',
  DARKER_GREY = '#49494B',
  TRANSPARENT_DARKER_GREY = 'rgba(27.5, 27.5, 30, 0.8)', // same color as DARKER_GREY on white background, but with transparency
  DARK_GREY = '#6D6D6F',
  DARKEST_MEDIUM_GREY = '#8D8D8F', // move away from this
  DARK_MEDIUM_GREY = '#BDBDBF',
  LIGHT_DARK_MEDIUM_GREY = '#D7D7D7',
  MEDIUM_GREY = '#E5E5E7', // mostly used for borders
  LEGACY_GRAY = '#E8E8E9', // Use this for something?
  GREY = '#EBEBED',
  TRANSPARENT_GREY = 'rgba(95, 95, 111, 0.125)', // same color as GREY on white background, but with transparency
  LIGHT_GREY = '#F6F6F9', // mostly used for backgrounds
  BACKGROUND_GREY = '#fbfbfc',
  WHITE = '#FFFFFF',
  DARKEST_BLUE = '#062754',
  DARK_BLUE = '#0B3F87', // or this #1657be
  BLUE = '#0E55B8',
  MEDIUM_BLUE = '#3A74C8',
  LIGHT_BLUE = '#6592D8',
  MEDIUM_LIGHT_BLUE = '#89B1EC',
  TRANSPARENT_BLUE = '#ACCFFF',
  LIGHTER_BLUE = '#CBE0FF',
  LIGHTEST_BLUE = '#F0F5FF',
  DARK_PURPLE = '#5149D4',
  DARKEST_PURPLE = '#4A3DA9',
  DEEP_PURPLE = '#5855EB',
  PURPLE = '#6C63FF',
  LIGHT_PURPLE = '#DBDAF9',
  LIGHTEST_PURPLE = '#F0EFFE',
  TRANSPARENT_PURPLE = '#E1E0FF',
  VIOLET = '#A953B5',
  PINK = '#F35D98',
  DARK_RED = '#85261D',
  MEDIUM_DARK_RED = '#B73528',
  RED = '#E84333',
  MEDIUM_RED = '#EF796D',
  LIGHT_MEDIUM_RED = '#F29289',
  LIGHT_RED = '#F5AEA8',
  TRANSPARENT_RED = '#F7C9C4',
  LIGHTER_RED = '#FCE4E2',
  LIGHTEST_RED = '#FEF2F1',
  DARK_YELLOW = '#806050',
  GOLDEN_ROD = '#DAA520',
  MEDIUM_YELLOW = '#F2C94C',
  YELLOW = '#FDE68A',
  BRIGHT_YELLOW = '#fad436',
  ORANGE = '#F29D4E',
  LIGHT_YELLOW = '#FEF3C5',
  DARKEST_GREEN = '#053819',
  DARKER_GREEN = '#0A7033',
  DARK_GREEN = '#0FA74C',
  GREEN = '#0CC757',
  MEDIUM_GREEN = '#75E1A1',
  LIGHT_GREEN = '#BEEFC6',
  LIGHTER_GREEN = '#DDFBEA',
  TRANSPARENT_GREEN = '#E7FAEF',
}
